import React from "react";
import { Link } from "react-router";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const AttachmentButton: React.FC = () => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button
        variant="outline"
        size="sm"
        className="cursor-pointer border-slate-900 bg-slate-900 text-white hover:bg-slate-800 hover:text-white"
        title="Add attachment"
      >
        <Plus className="mr-1 h-4 w-4" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="start" className="min-w-[150px]">
      <DropdownMenuItem asChild>
        <Link to="/drive" className="cursor-pointer">
          My Folders
        </Link>
      </DropdownMenuItem>
      <DropdownMenuItem asChild>
        <Link to="/shared" className="cursor-pointer">
          Shared with me
        </Link>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);
